// Signed in, nothing to work on yet. A page of the app, not the marketing landing: the product
// name, the wallet, one line, and the same import form Landing uses. Submitting it lands on the
// import screen like any other import.
import { useQueryClient } from '@tanstack/react-query';
import { PLAN_META } from '@str/shared';
import { useNavigate } from 'react-router';
import { CreditsMeter } from '@/components/CreditsMeter';
import { ImportForm } from '@/components/ImportForm';
import { Logo } from '@/components/ui';
import { authClient } from '@/lib/auth-client';
import { initials } from '@/lib/format';
import type { Me } from '@/lib/queries';

export function FirstProperty({ me }: { me: Me }) {
  const navigate = useNavigate();
  const qc = useQueryClient();
  const user = me.user!;
  const grant = me.subscription ? PLAN_META[me.subscription.plan].creditsPerMonth : 0;
  const signOut = async () => {
    await authClient.signOut();
    qc.clear();
    void navigate('/login', { replace: true });
  };

  return (
    <div
      className="app-shell"
      style={{
        flex: 1,
        minWidth: 0,
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        background: 'var(--bg)',
        overflow: 'auto',
      }}
    >
      <header
        style={{
          display: 'flex',
          alignItems: 'center',
          gap: 16,
          padding: '14px 24px',
          background: '#fff',
          borderBottom: '1px solid rgba(0,0,0,.06)',
        }}
      >
        <Logo to="/app" size={17} />
        <div style={{ marginLeft: 'auto', display: 'flex', alignItems: 'center', gap: 14 }}>
          {me.credits && (
            <div style={{ width: 200 }}>
              <CreditsMeter credits={me.credits} grant={grant} />
            </div>
          )}
          <span
            style={{ display: 'flex', alignItems: 'center', gap: 8, fontSize: 12.5, minWidth: 0 }}
          >
            <span className="avatar">{initials(user.name) || 'H'}</span>
            <span style={{ fontWeight: 700 }}>{user.name}</span>
          </span>
          <button
            type="button"
            className="btn btn-ghost hv"
            style={{ fontSize: 12.5, padding: '7px 12px' }}
            onClick={() => void signOut()}
          >
            Sign out
          </button>
        </div>
      </header>
      <main style={{ flex: 1, display: 'grid', placeItems: 'center', padding: '32px 24px' }}>
        <div
          className="a-rise"
          style={{
            width: '100%',
            maxWidth: 560,
            display: 'flex',
            flexDirection: 'column',
            gap: 18,
          }}
        >
          <div style={{ display: 'flex', flexDirection: 'column', gap: 8 }}>
            <h1 style={{ fontSize: 28, fontWeight: 800, letterSpacing: '-.03em', margin: 0 }}>
              Add your first property
            </h1>
            <p style={{ margin: 0, fontSize: 14, color: '#666', lineHeight: 1.5 }}>
              Paste one link. We pull your photos and description, draft the posts, and you approve.
            </p>
          </div>
          <ImportForm loggedIn />
          <div
            style={{
              display: 'flex',
              alignItems: 'center',
              gap: 8,
              fontSize: 13,
              color: '#777',
              flexWrap: 'wrap',
            }}
          >
            <span>Works with</span>
            {['Airbnb', 'VRBO', 'Direct site'].map((c) => (
              <span
                key={c}
                style={{
                  padding: '5px 10px',
                  borderRadius: 8,
                  background: '#fff',
                  border: '1px solid rgba(0,0,0,.08)',
                  fontWeight: 600,
                  color: '#333',
                }}
              >
                {c}
              </span>
            ))}
          </div>
        </div>
      </main>
    </div>
  );
}
